import React from "react";
import emptyState from "../../redux/store/emptyState.js";
import { preloadResources as preloadCrossSellResources } from "../CrossActivity/loader.js";
import { preload as preloadLanguageHeaderMenuItem } from "../../components/LanguageSwitcher/index.js";
import { preload as preloadOddsFormatItem } from "../../components/Odds/index.js";
import { SettingsPC } from "../../components/Settings/loader.js";
import { PageContextUtils, LazyLoadUtils } from "../../utils/index.js";

export const HeaderChunk = LazyLoadUtils.lazyWithFallback(
  () => import(/* webpackChunkName: "header" */ "./Header.js"),
  { componentName: "Header" }
);

export const HeaderButtonsPC = LazyLoadUtils.lazyWithFallback(
  () =>
    import(/* webpackChunkName: "header/pc/buttons" */ "./HeaderButtonsPC.js"),
  { componentName: "HeaderButtonsPC" }
);

export const HeaderButtonsMobile = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "header/mobile/buttons" */ "./HeaderButtonsMobile.js"
    ),
  { componentName: "HeaderButtonsMobile" }
);

export const HeaderLogoReward = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "header/logo-reward" */ "./HeaderLogoReward.js"
    ),
  { componentName: "HeaderLogoReward" }
);

export const getHeaderLayoutComponent = (
  brandId,
  clientProvider,
  deviceType
) => {
  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${brandId}/${clientProvider}/Header.${deviceType?.toLowerCase()}.layout.js`
      ),
    { componentName: "HeaderLayout" }
  );
};

export const getLeftHeaderLayoutComponent = (
  brandId,
  clientProvider,
  deviceType
) => {
  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${brandId}/${clientProvider}/LeftHeader.${deviceType?.toLowerCase()}.layout.js`
      ),
    { componentName: "LeftHeaderLayout" }
  );
};

export const getHeaderLayout = (brandId, deviceType) => {
  let layout = React.Fragment;
  const { name } = PageContextUtils.getClientProviderData();
  layout = getHeaderLayoutComponent(brandId, name, deviceType);

  return layout;
};

export const getLeftHeaderLayout = (brandId, deviceType) => {
  let layout = React.Fragment;
  const { name } = PageContextUtils.getClientProviderData();
  layout = getLeftHeaderLayoutComponent(brandId, name, deviceType);

  return layout;
};

export const preloadHeaderResources = () => {
  const brandId = window.__UAA_STATE__?.userContext.brandId;
  const deviceType = emptyState.userContext.deviceType;
  const { name } = PageContextUtils.getClientProviderData();
  const isPC = deviceType.toLocaleLowerCase() === "pc";
  const isSettingsDrawerEnabled = emptyState.settings.isEnabled;

  preloadCrossSellResources(isPC);
  getHeaderLayoutComponent(brandId, name, deviceType).preload();
  HeaderChunk.preload();
  if (isPC) {
    if (!isSettingsDrawerEnabled) {
      preloadOddsFormatItem({ isPC: true, clientProvider: name });
      preloadLanguageHeaderMenuItem(true);
    } else {
      SettingsPC.preload();
    }
    HeaderButtonsPC.preload();
    HeaderLogoReward.preload();
  } else {
    HeaderButtonsMobile.preload();
  }
};
